<template>
  <div>
    <h2>Please, turn your phone landscape.</h2>
  </div>
</template>

<script>
export default {
  name: 'Portrait',
}
</script>

<style lang="scss" scoped>

div {
  position: fixed;
  z-index: 1000000000;
  height: 100%;
  width: 100%;
  background: black;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;

  h2 {
    width: 80%;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Portrait.vue